import { Box, Button, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import { FiCheckCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { urls } from "../../urls";

export const NeedSubmitted = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex direction="column" align="center" justify="center" minH="60vh">
      <Box
        bg="smBackground"
        rounded="xl"
        border="1px solid"
        borderColor="smBorder"
        p="10"
        textAlign="center"
        maxW="480px"
        w="full"
      >
        <Flex w="20" h="20" rounded="full" bg="smSuccessSoft" align="center" justify="center" mx="auto" mb="5">
          <Icon as={FiCheckCircle} boxSize="40px" color="smSuccess" />
        </Flex>
        <Heading as="h2" size="lg" color="smText">
          {t("The need has been registered!")}
        </Heading>
        <Text fontSize="sm" color="smMuted" mt="3">
          {t(
            "Your need has been sent to the procurement department for review. You will be notified when the status changes.",
          )}
        </Text>
        <Button mt="8" colorScheme="teal" onClick={() => navigate(urls.app.needs.mine)}>
          {t("Go to my needs")}
        </Button>
      </Box>
    </Flex>
  );
};
